import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f482efa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "auth-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spotlight-container" }, [
  /*#__PURE__*/_createElementVNode("header", null, [
    /*#__PURE__*/_createElementVNode("img", { src: "https://static.caderio.com/assets/logos/chatcaptain-logo.png" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "spotlight" }, [
    /*#__PURE__*/_createElementVNode("img", { src: "https://chatcaptain.de/assets/img/interbots/light--grosse-lasten.svg" }),
    /*#__PURE__*/_createElementVNode("h2", null, "My awesome punchline!")
  ])
], -1))
const _hoisted_4 = { class: "auth-form-wrapper" }
const _hoisted_5 = { class: "switch-view-action" }
const _hoisted_6 = { class: "auth-form" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Passwort vergessen?", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Bitte gebe unten deine E-Mail-Adresse ein, damit wir dir einen Link zum Zurücksetzen deines Passworts zusenden können. ", -1))
const _hoisted_9 = { class: "fields" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legal" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://chatcaptain.com/imprint.html",
    target: "_blank"
  }, "Impressum"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://chatcaptain.com/privacy.html",
    target: "_blank"
  }, "Datenschutz"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://chatcaptain.com/sbt.html",
    target: "_blank"
  }, "AGB")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_button = _resolveComponent("md-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_md_input_field = _resolveComponent("md-input-field")!
  const _component_md_input_field_wrapper = _resolveComponent("md-input-field-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, { to: "/sign-in" }, {
            default: _withCtx(() => [
              _createVNode(_component_md_button, { variant: "outlined" }, {
                default: _withCtx(() => [
                  _createTextVNode("Zurück zum Login")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_md_input_field_wrapper, null, {
              default: _withCtx(() => [
                _createVNode(_component_md_input_field, {
                  variant: "filled",
                  type: "email",
                  label: "E-Mail-Adresse",
                  icon: "email"
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_md_button, {
            variant: "filled",
            onClick: _ctx.login
          }, {
            default: _withCtx(() => [
              _createTextVNode("Neues Passwort anfordern")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _hoisted_10
      ])
    ])
  ]))
}